import walkaroundVideo from './images/atto2/atto2-walkaround.mp4';
import walkaroundPoster from './images/atto2/atto2-walkaround-poster.jpg';

// Video walkaround unit display BYD Atto 2 (720x1280, 1 menit 12 detik).
// Dipakai di halaman model /jelajahi-atto2 dan artikel blog Atto 2.
export const ATTO2_VIDEO = {
  src: walkaroundVideo,
  poster: walkaroundPoster,
  durationSeconds: 72,
  uploadDate: '2026-11-02',
  ariaLabel: 'Video walkaround unit display BYD Atto 2 di showroom',
  name: 'Video walkaround BYD Atto 2: eksterior, kokpit, dan fitur kabin',
  description:
    'Walkaround unit display BYD Atto 2 warna Cosmos Black: flush door handle, kokpit dengan column shifter, konsol tengah dengan wireless charging 50 W, kamera 360 derajat di layar putar, panel pintu belakang, dan lampu belakang menerus.',
  chapters: [
    { time: 0, label: 'Tampak depan', text: 'Dragon Face dan lampu LED Atto 2 di showroom.' },
    { time: 8, label: 'Flush door handle', text: 'Handle pintu rata bodi yang muncul saat disentuh.' },
    { time: 16, label: 'Kokpit dan setir', text: 'Setir dua palang, panel instrumen digital, layar putar.' },
    { time: 24, label: 'Column shifter', text: 'Tuas transmisi di kolom setir, konsol tengah jadi lega.' },
    { time: 32, label: 'Wireless charging 50 W', text: 'Konsol tengah dengan tombol mode berkendara.' },
    { time: 40, label: 'Kamera 360 derajat', text: 'Tampilan kamera keliling di layar 12,8 inci.' },
    { time: 62, label: 'Pintu dan kabin belakang', text: 'Panel pintu belakang, speaker, dan ruang baris kedua.' },
    { time: 69, label: 'Lampu belakang menerus', text: 'Light bar selebar bodi dengan logo BYD.' },
  ],
};
